// function getUnique(arr, comp) {
//   //store the comparison  values in array
//   const unique = arr
//     .map(e => e[comp])
//     // store the keys of the unique objects
//     .map((e, i, final) => final.indexOf(e) === i && i)
//     // eliminate the dead keys & return unique objects
//     .filter(e => arr[e])
//     .map(e => arr[e]);

//   return unique;
// }

export default {
  setToken(state, token) {
    state.token = token;
  },
  setClientStatus(state, status) {
    state.client_status = status;
  },
  setEmployee(state, employee) {
    state.employee = employee;
  },
  setCompanies(state, companies) {
    state.companies = companies;
  },
  setSubCompanies(state, data) {
    state.sub_companies = data;
  },
  setInitialMenu(state, menu) {
    state.initialMenu = menu;
  },
  setMenu(state, menu) {
    state.menu = menu;
  },
  setMainMenu(state, menu) {
    state.main_menu = menu;
  },
  setCompanyMenu(state, menu) {
    state.company_menu = menu;
  },
  setSubCompanyMenu(state, menu) {
    state.sub_company_menu = menu;
  },
  setBookingAgentMenu(state, menu) {
    state.booking_agent_menu = menu;
  },
  setBookingClientMenu(state, menu) {
    state.booking_client_menu = menu;
  },
  setModule(state, menu) {
    state.module = menu;
  },
  setInfobar(state, info) {
    state.infobar = info;
  },
  setInfobarStatus(state, info) {
    state.infobarStatus = info;
  },
  setUnauthorized(state, status) {
    state.unauthorized = status;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setTempData(state, data) {
    // state.tempData = getUnique(state.tempData.concat(data), "id");
    state.tempData = data;
  },
  initiateTempData(state) {
    state.tempData = [];
  },
  setCompany(state, data) {
    state.company = data;
  },
  setSubCompany(state, data) {
    state.subcompany = data;
  },
  setBookingAgent(state, data) {
    state.booking_agent = data;
  },
  setBookingClient(state, data) {
    state.booking_client = data;
  },
  setEnableNavDrawer(state, data) {
    state.enableNavDrawer = data;
  },
  setFareMatrixItems(state, data) {
    state.fareMatrixItems = data;
  },
};
